/******************************************************************************
 *
 * Copyright (c) 2019-2020 ServiceActivator Inc. All Rights Reserved.
 *
 * Unauthorized copying of the code in this file, completely or partially,
 * via any medium is strictly prohibited.
 *
 * Proprietary and Confidential.
 *
 * Written by 'Vishal Goel’ <vishal@wakencode.com>, February 2020
 *
 *****************************************************************************/

import * as actionTypes from "./actionTypes";

//  update the info window checkbox status in geofence
export const updateShowInfoWindowCheckBox = (isChecked) => {
  return {
    type: actionTypes.UPDATE_INFO_WINDOW_CHECKBOX,
    isChecked,
  };
};

// update the work order assigned user checkbox status in geofence
export const updateShowWorkOrderUserInfoCheckBox = (isChecked) => {
  return {
    type: actionTypes.UPDATE_WORK_ORDER_USER_INFO_BOX_CHECKBOX,
    isChecked,
  };
};

// update the selected job filter value
export const updateJobTypeFilterValue = (jobType) => {
  return {
    type: actionTypes.UPDATE_JOB_TYPE_FILTER,
    jobType,
  };
};

// update the selected user filter value
export const updateUserFilterValue = (user) => {
  return {
    type: actionTypes.UPDATE_USER_FILTER,
    user,
  };
};

// update when created/updated geofence is saved or not
export const setPathSaveStatus = (status) => {
  return {
    type: actionTypes.SET_PATH_SAVE_STATUS,
    status,
  };
};
